module.exports = __webpack_public_path__ + "img/title-bg.9f7e5b0c.png";